import { useState } from "react";
import { useIntl } from "react-intl";
import { type DocumentResource } from "@/lib/document-resource";
import { openDocumentResource } from "@/stores/document-preview-store";
import { userErrorMessage } from "@/lib/user-error";
import { DocumentThumbnail } from "./DocumentThumbnail";
import { DocumentOpenButton } from "./DocumentOpenButton";

/** A preview beside a file label or selection control; opening never selects/removes it. */
export function DocumentInline({ file, id, previewSrc, label, labelId, showName, openLabel }: {
  file: DocumentResource; id?: string; previewSrc?: string | null; label?: string; labelId?: string; showName?: boolean; openLabel?: string;
}) {
  const intl = useIntl();
  const resource = file;
  const [error, setError] = useState<unknown>();
  const named = Boolean(label || showName);
  // Only a shown name can give way; without one, shrinking would push the fixed preview and button under a neighbour.
  return <span className={`inline-flex items-center gap-1 ${named ? "min-w-0" : "shrink-0"}`} onClick={event => event.stopPropagation()}>
    <span className="h-10 w-8 shrink-0 overflow-hidden rounded bg-ink/[0.06]">
      <DocumentThumbnail resource={resource} previewSrc={previewSrc} compact fallback={<span aria-hidden>📄</span>} />
    </span>
    <span className="shrink-0"><DocumentOpenButton openLabel={openLabel} id={id} resource={resource} name={resource.name} onOpen={() => {
      setError(undefined);
      void openDocumentResource(resource).catch(setError);
    }} /></span>
    {named ? <span id={labelId} className="min-w-0 truncate text-ink">{label ?? file.name}</span> : null}
    {error ? <span role="alert" className="text-smycles-meta">{userErrorMessage(intl, error)}</span> : null}
  </span>;
}
